import { Avatar, Card, CardContent, CardHeader, Chip, lighten, makeStyles, MuiThemeProvider, Typography } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import ServiceCardTypes from './ServiceCard.types';
import ReactJson from 'react-json-view';

import Themes from "src/themes";
import { yiq } from 'yiq';
import isEmpty from 'lodash.isempty';

const useStyles = makeStyles((theme) => {
  return {
    statusChip: {
      marginLeft: theme.spacing(1)
    },
    statusChipList: {
      display: 'flex',
      flexDirection: 'column',
    },
    extras: {
      display: 'flex',
      flexWrap: 'wrap',
      listStyle: 'none',
      padding: theme.spacing(0.5),
      margin: 0,
    },
    extrachip: {
      margin: theme.spacing(0.5),
    },
    cardStatusChip: {
      backgroundColor: ({ color }) => lighten(color, .5),
      fontWeight: 'bold',
      
    },
    card: {
      backgroundColor: ({ color }) => color,
      backgroundImage: ({ backdrop }) => backdrop ? `url(${backdrop})` : 'none',
      backgroundRepeatX: 'no-repeat',
      backgroundRepeat: 'no-repeat',
      backgroundRepeatY: 'no-repeat',
      backgroundPosition: ({ offset }) => `bottom ${offset.bottom}px right ${offset.right}px`,
      backgroundSize: ({ size }) => `auto ${size}px`,

      minHeight: 220,
      [theme.breakpoints.down("md")]: {
        paddingBottom: ({ size }) => `${size}px`,
      },
      
    },
    content: {
      [theme.breakpoints.up("md")]: {
        width: ({ size }) => `calc(100% - ${size}px)`,
      },
      [theme.breakpoints.down("md")]: {
        width:  '100%',
      },
    },
    cardRoot: {
      alignItems: "flex-start",
      alignContent: "flex-start",
    },
    cardTitle: {
      
    },
    cardAction: {
      margin:0,
      alignSelf:'center'
    },
  }
})

const sort = (a, b) => {
  const nameA = a.toUpperCase();
  const nameB = b.toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
}

const ServiceCard = ({ cardSetup, children }) => {
  const classes = useStyles(cardSetup)

  const renderStatusChips = useMemo(
    () => {
      return <div className={classes.statusChipList}>
        <Chip
            size="small"
            className={classes.cardStatusChip}
            label={cardSetup?.statuses?.label}

            // variant={status.variant}
          />
        
      </div>
    },
    [cardSetup?.statuses, classes.cardStatusChip, classes.statusChipList],
  );
  return (
    <Card className={classes.card}>
      <CardHeader
        classes={{
          root: classes.cardRoot,
          title: classes.cardTitle,
          action: classes.cardAction,
        }}
        title={cardSetup?.label} subheader={cardSetup?.subHeader}
        action={renderStatusChips}
      />
      {/* <CardContent>
        <Typography className={classes.content} variant="body2" color="textPrimary" component="p">{cardSetup?.content}</Typography>
      </CardContent> */}
      {!isEmpty(cardSetup?.packages) && (
        <CardContent className={classes.content}>
          <Typography variant="body1" color="textPrimary" component="p">Packages:</Typography>
          <div className={classes.extras}>
            {(cardSetup?.packages ?? [])?.sort(sort).join(', ')}
          </div>
        </CardContent>
      )}
      {!isEmpty(cardSetup?.packageItems) && (
        <CardContent className={classes.content}>
          <div className={classes.extras}>
            {(cardSetup?.packageItems ?? [])?.sort(sort).join(', ')}
          </div>

        </CardContent>
      )}
      {children}
    </Card>
  )
}

const WrappedCard = ({ cardSetup, ...props }) => {
  if (isEmpty(cardSetup)) return <></>

  const colorYiq = yiq(cardSetup?.color??'#fff', { threshold: 128 })
  const theme = colorYiq === '#000' ? Themes.dark : Themes.default

  return (
    <MuiThemeProvider theme={theme}>
      <ServiceCard cardSetup={cardSetup} {...props} />
    </MuiThemeProvider>
  )
}

export { WrappedCard as ServiceCard, ServiceCardTypes }
